/** Admin voucher claims drill-down (who claimed a gift/promo) for one owner. */
import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import { OwnerScopeProvider } from '../../../../../../src/context/OwnerScopeContext';
import VoucherClaimsScreen from '../../../../../owner/subscriptions/vouchers/[id]';

export default function AdminOwnerVoucherClaimsScreen() {
  const { id, voucherId } = useLocalSearchParams<{ id: string; voucherId: string }>();
  return (
    <OwnerScopeProvider ownerId={id}>
      <VoucherClaimsScreen entityId={voucherId} />
    </OwnerScopeProvider>
  );
}
